import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { LogService } from '../../services/log.service';
import {ApiService} from "../../services/api.service";
import {DataService} from "../../services/data.service";
import {FrontEndService} from "../../services/front-end.service";

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  loading = false;

  constructor(private stateService: StateService,
              private apiService: ApiService,
              private dataService: DataService,
              private frontEndService: FrontEndService,
              private logService: LogService) {
  }

  ngOnInit() {
    if (localStorage.getItem('remember') === 'true') {
      this.stateService.go('dashboard');
    }

    const url = new URL(window.location.href);

    if (url.searchParams.get("oauth_verifier") !== null && url.searchParams.get("oauth_token") !== null) {
      const body = {
        oauth_token: url.searchParams.get("oauth_token"),
        oauth_verifier: url.searchParams.get("oauth_verifier")
      };
      console.log("Twitter login request - ", body);

      this.loading = true;
      this.apiService.twitterLogin(body, (response) => {
        console.log("Twitter login response - ", response);

        if (response['response'].toLowerCase() === 'ok') {
          localStorage.setItem('user', JSON.stringify(response));
          localStorage.setItem('remember', "true");
          this.dataService.getLoginUserDetails();
          this.dataService.menuOptions();
          this.stateService.go('dashboard');
        } else {
          // Remove parameters
          window.history.pushState({}, "Goldkeys Hub", window.location.origin);
        }
        this.loading = false;
      });
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/landing-page/landing-page.component.ts